import { render, staticRenderFns } from "./customField.vue?vue&type=template&id=2768d4ec&scoped=true&"
import script from "./customField.vue?vue&type=script&lang=js&"
export * from "./customField.vue?vue&type=script&lang=js&"
import style0 from "./customField.vue?vue&type=style&index=0&id=2768d4ec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2768d4ec",
  null
  
)

export default component.exports